import React, { ReactChild } from 'react';
import { Page } from '@hopskipdrive/react-components';

import { useAuth } from '../../../contexts/AuthContext';
import { PageLoader } from '../PageLoader';

interface PageLayoutProps {
  children: ReactChild;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  const { user, loading } = useAuth();

  return !loading ? (
    <>
      {user ? (
        <Page>
          {children}
          <PageLoader />
        </Page>
      ) : (
        children
      )}
    </>
  ) : null;
};
